export default __webpack_public_path__ + "static/10-665cf709ce59b326b316f48083e67113.jpg";